import React from 'react';
import LoadingScreen from 'src/frontend-common/components/LoadingScreen';
import ErrorBoundary from 'src/frontend-common/components/MicroServiceErrorBundary';
import { ExportListProps } from 'src/frontend-common/dto/Interfaces/FrontendLookups';

const ExportListRemote: React.FC<ExportListProps> = (props) => {
  const ExportList: React.FC<ExportListProps> = React.lazy(() => import('FrontendLookups/ExportsList'));

  return (
    <ErrorBoundary>
      <React.Suspense fallback={<LoadingScreen variant="circle" />}>
        <ExportList {...props} />
      </React.Suspense>
    </ErrorBoundary>
  );
};
export default ExportListRemote;
